<div class="relative flex items-center justify-center p-3">
    <h3 mat-dialog-title class="text-lg font-bold !mb-0">TERMS & CONDITIONS</h3>
    <div class="absolute right-3">
        <material-button
            [buttonType]="'icon'"
            [size]="'small'"
            [titleText]="'Close'"
            [prefixIcon]="'close'"
            mat-dialog-close
            [classList]="['focus:outline-none']"></material-button>
    </div>
</div>
<mat-dialog-content class="p-6 prose max-w-none max-h-[70vh] overflow-y-auto !m-0">
    <mat-tab-group>
        <mat-tab label="End User Agreement">
            <div class="p-6 prose max-w-none">
                <p class="my-2">
                    This End User License Agreement ("Agreement") is a legal agreement between you ("End User") and Taxilla IT Solutions
                    Pvt. Ltd. ("Provider") governing your access and use of the software, platform, and services (collectively, the
                    "Software") provided to you as an authorized user under this valid license agreement.
                </p>
                <p class="my-2">By accessing, installing, or using the Software, you agree to be bound by the terms of this Agreement.</p>
                <h3 class="my-2 font-bold">1. LICENSE GRANT AND RESTRICTIONS</h3>
                <h4 class="my-2 ml-3 font-semibold">1.1 License Grant.</h4>
                <p class="ml-6">
                    Provider grants End User a limited, non-exclusive, non-transferable, non-sublicensable right to access and use the
                    Software solely internal business purposes and only as authorized under this Agreement.
                </p>
                <h4 class="my-2 ml-3 font-semibold">1.2 Restrictions.</h4>
                <p class="ml-6">End User shall not:</p>
                <ul class="ml-10 list-disc">
                    <li class="my-1">Modify, copy, reverse-engineer, decompile, or disassemble the Software;</li>
                    <li class="my-1">Transfer, sublicense, resell, or otherwise make the Software available to third parties;</li>
                    <li class="my-1">Use the Software for any unlawful or unauthorized purpose;</li>
                    <li class="my-1">Circumvent or disable any access controls or usage restrictions;</li>
                    <li class="my-1">Introduce harmful code or attempt unauthorized access to systems;</li>
                    <li class="my-1">Use the Software to develop a competing service or product.</li>
                </ul>
                <p class="ml-6">
                    Use of any third-party materials integrated with the Software is subject to their respective license terms.
                </p>

                <h3 class="my-2 font-bold">2. ACCESS AND SECURITY</h3>
                <h4 class="my-2 ml-3 font-semibold">2.1. Credentials.</h4>
                <p class="ml-6">
                    End User must maintain the confidentiality of access credentials. Sharing of credentials is prohibited. End User shall
                    notify Provider of any unauthorized access or suspected breach.
                </p>
                <h4 class="my-2 ml-3 font-semibold">2.2. System Security.</h4>
                <p class="ml-6">
                    End User must use reasonable measures to secure their devices and systems from unauthorized use or interference with the
                    Software.
                </p>

                <h3 class="my-2 font-bold">3. DATA USE AND OWNERSHIP</h3>
                <h4 class="my-2 ml-3 font-semibold">3.1. End User Data.</h4>
                <p class="ml-6">
                    All data submitted or generated through the Software by End User is owned by them. Provider may process such data solely
                    for delivering services under this Agreement.
                </p>
                <h4 class="my-2 ml-3 font-semibold">3.2. Resultant Data.</h4>
                <p class="ml-6">
                    Provider may generate Resultant Data (aggregated, anonymized data) that does not identify any individual or End User and
                    may use such data for service improvement.
                </p>
                <h4 class="my-2 ml-3 font-semibold">3.3. Data Protection.</h4>
                <p class="ml-6">
                    End User shall not submit any data through the Software that violates applicable data privacy laws or the rights of
                    third parties.
                </p>

                <h3 class="my-2 font-bold">4. OWNERSHIP AND INTELLECTUAL PROPERTY</h3>
                <p class="ml-3">
                    All rights, title, and interest in the Software, including updates and enhancements, are and shall remain the exclusive
                    property of Provider or its licensors. No rights are granted except as expressly provided in this Agreement.
                </p>

                <h3 class="my-2 font-bold">5. TERM AND TERMINATION</h3>
                <h4 class="my-2 ml-3 font-semibold inline-block">5.1.</h4>
                <p class="inline-block">
                    This Agreement is effective until terminated by either by End User or Provider by providing a 60 days prior notice.
                </p>
                <h4 class="my-2 ml-3 font-semibold">5.2. Access may be revoked if:</h4>
                <ul class="ml-10 list-disc">
                    <li class="my-1">The End User's subscription ends;</li>
                    <li class="my-1">There is a breach of this Agreement.</li>
                </ul>
                <h4 class="my-2 ml-3 font-semibold inline-block">5.3.</h4>
                <p class="inline-block">
                    Upon termination, End User shall cease all use of the Software. The obligations in Sections 4, 6, 7, 8, 10, and 11 will
                    survive termination.
                </p>

                <h3 class="my-2 font-bold">6. CONFIDENTIALITY</h3>
                <h4 class="my-2 ml-3 font-semibold">6.1. Obligation.</h4>
                <p class="ml-6">
                    End User shall treat all non-public information of Provider, including the Software and related materials, as
                    confidential and shall not disclose it without written consent.
                </p>
                <h4 class="my-2 ml-3 font-semibold">6.2 Duration.</h4>
                <p class="ml-6">This confidentiality obligation shall continue for eight (8) years from the date of termination.</p>
                <h4 class="my-2 ml-3 font-semibold">6.3 Exceptions.</h4>
                <p class="ml-6">This obligation does not apply to information that:</p>
                <ul class="ml-10 list-disc">
                    <li class="my-1">is publicly available without breach;</li>
                    <li class="my-1">Was lawfully known to End User;</li>
                    <li class="my-1">Is disclosed under legal compulsion, with prompt written notice.</li>
                </ul>

                <h3 class="my-2 font-bold">7. WARRANTY DISCLAIMER</h3>
                <p class="ml-3">
                    The Software is provided "as is." Provider disclaims all warranties, express or implied, including fitness for a
                    particular purpose, merchantability, and non-infringement.
                </p>

                <h3 class="my-2 font-bold">8. LIMITATION OF LIABILITY</h3>
                <p class="ml-3">
                    To the maximum extent permitted by law, Provider shall not be liable for any indirect, incidental, special,
                    consequential, punitive or exemplary damages, or for any loss of data, business, or profits, arising from the use of the
                    Software, even if advised of the possibility of such damages.
                </p>
                <p class="ml-3">
                    Except as otherwise provided under this Agreement, in no event will the aggregate liability of Provider under or in
                    connection with this Agreement, under any legal theory, exceed the aggregate amount of the discrete value of services
                    provided under this Agreement in the twelve-month period prior to the event giving rise to liability. These limitations
                    shall apply notwithstanding the failure of any limited remedy of its essential purpose.
                </p>

                <h3 class="my-2 font-bold">9. INDEMNIFICATION</h3>
                <h4 class="my-2 ml-3 font-semibold">9.1. By End User.</h4>
                <p class="ml-6">
                    End User agrees to indemnify and hold harmless Provider and its affiliates from any third-party claims or losses
                    resulting from:
                </p>
                <ul class="ml-10 list-disc">
                    <li class="my-1">Breach of this Agreement;</li>
                    <li class="my-1">Unauthorized or illegal use of the Software;</li>
                    <li class="my-1">Submitted content that violates third-party rights;</li>
                    <li class="my-1">End User's gross negligence or wilful misconduct.</li>
                </ul>
                <h4 class="my-2 ml-3 font-semibold">9.2. By Provider.</h4>
                <p class="ml-6">
                    Provider shall indemnify End User against third-party IP infringement claims relating to the Software, when used in
                    accordance with this Agreement. This does not apply to claims resulting from:
                </p>
                <ul class="ml-10 list-disc">
                    <li class="my-1">Unauthorized modifications;</li>
                    <li class="my-1">Use with unapproved third-party products;</li>
                    <li class="my-1">Failure to implement updates;</li>
                    <li class="my-1">Breach by the End User.</li>
                </ul>

                <h3 class="my-2 font-bold">10. COMPLIANCE WITH LAWS AND EXPORT CONTROL</h3>
                <p class="ml-3">
                    End User shall comply with all applicable laws and regulations. The Software may not be used, exported, or re-exported
                    in violation of applicable export laws, including to embargoed countries or restricted persons.
                </p>

                <h3 class="my-2 font-bold">11. GOVERNING LAW AND SPECIFIC COUNTRY LAWS</h3>
                <p class="ml-3">
                    This Agreement shall be governed by and construed in accordance with the governing law specified in the applicable
                    Master Services Agreement, if any entered into between the Parties. In the absence of such an MSA, this Agreement shall
                    be governed by the laws of India, and the Parties agree to submit to the exclusive jurisdiction of the courts located in
                    Hyderabad, Telangana, India. Each Party further agrees to be bound by and comply with the country-specific terms
                    applicable to its jurisdiction, as set forth in the Official Website of Taxilla under the category (Country-Specific
                    Terms), which shall form an integral part of this Agreement.
                </p>

                <h3 class="my-2 font-bold">12. SERVICE LEVEL AGREEMENT (SLA)</h3>
                <p class="ml-3">
                    The End User acknowledges and agrees that the service levels applicable to the Software are governed by the specific
                    Service Level Agreement (SLA) corresponding to the product in use. The relevant SLA is made available on the Provider's
                    official website and forms an integral part of this Agreement. By using the Software, the End User agrees to comply with
                    and be bound by the applicable SLA, as updated from time to time.
                </p>

                <h3 class="my-2 font-bold">13. PRIVACY AND DATA PROTECTION</h3>
                <p class="ml-3">
                    The Provider's handling of End User data is governed by its Privacy Policy, available on the Provider's official
                    website. By using the Software and accepting this Agreement, the End User expressly agrees to the terms of the Privacy
                    Policy, including any updates. The Privacy Policy shall be deemed to be incorporated by reference into this Agreement
                    and governs the collection, use, storage, and protection of End User data.
                </p>

                <h3 class="my-2 font-bold">14. FORCE MAJEURE</h3>
                <p class="ml-3">
                    The Provider shall not be liable for any failure or delay in performance due to circumstances beyond its reasonable
                    control, including but not limited to acts of God, natural disasters, war, or internet outages.
                </p>

                <h3 class="my-2 font-bold">15. ASSIGNMENT</h3>
                <p class="ml-3">
                    Neither party may assign this Agreement without prior written consent, except in cases of merger or acquisition.
                </p>

                <h3 class="my-2 font-bold">16. MODIFICATIONS</h3>
                <p class="ml-3">
                    The Provider may update this Agreement from time to time. Any material changes will be communicated via the Software or
                    email. Continued use of the Software following such updates shall constitute acceptance of the modified Agreement.
                </p>

                <h3 class="my-2 font-bold">17. ENTIRE AGREEMENT</h3>
                <p class="ml-3">
                    This Agreement constitutes the entire understanding between the parties and supersedes all prior agreements. Amendments
                    must be in writing and signed by both parties.
                </p>

                <p class="my-4 font-bold text-center">
                    BY USING THE SOFTWARE, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND AGREED TO BE BOUND BY THIS AGREEMENT.
                </p>
            </div>
        </mat-tab>
        <mat-tab label="Privacy Policy">
            <div class="p-6 prose max-w-none">
                <h2 class="text-xl font-bold text-center">Privacy Policy of Taxilla IT Solutions Pvt. Ltd.</h2>
                <p class="text-center">Effective Date: July 15, 2025</p>

                <h3 class="my-2 font-bold">Introduction</h3>
                <p class="my-2">
                    At Taxilla IT Solutions Pvt. Ltd. ("Taxilla", "we", "our", "us"), we are committed to protecting your personal
                    information. This Privacy Policy ("Policy") explains how we collect, use, disclose, and safeguard your information when
                    you visit our website
                    <a href="https://www.taxilla.com">(https://www.taxilla.com)</a>
                    or use any of our products and services, including any new services added in the future (collectively, the "Services").
                </p>

                <h3 class="my-2 font-bold">1. Information We Collect</h3>
                <p class="ml-3">We may collect the following types of information:</p>
                <ul class="ml-10 list-disc">
                    <li class="my-1">Personal Information: Such as your name, address, email address, phone number, and date of birth.</li>
                    <li class="my-1">Demographic and Profile Data: Including age, occupation, and income level.</li>
                    <li class="my-1">
                        Automatically Collected Data: Such as IP addresses, browser types, device identifiers, and site usage patterns.
                    </li>
                    <li class="my-1">
                        Public and Third-Party Data: Information from public platforms like social media, or third-party sources in
                        connection with your profile.
                    </li>
                    <li class="my-1">
                        User-Provided Content: Such as responses to surveys, queries, or participation in our forums, contests, and
                        promotional activities.
                    </li>
                </ul>

                <h3 class="my-2 font-bold">2. How We Use Your Information</h3>
                <p class="ml-3">We use your data for purposes including:</p>
                <ul class="ml-10 list-disc">
                    <li class="my-1">To manage and improve our Services.</li>
                    <li class="my-1">To respond to inquiries and provide support.</li>
                    <li class="my-1">To verify identity and ensure secure transactions.</li>
                    <li class="my-1">To deliver updates and communicate important information.</li>
                    <li class="my-1">To analyze trends and user behavior for service optimization.</li>
                    <li class="my-1">To comply with legal obligations and enforce our policies.</li>
                </ul>

                <h3 class="my-2 font-bold">3. Sharing of Information</h3>
                <p class="ml-3">We do not sell your personal information. We may share it:</p>
                <ul class="ml-10 list-disc">
                    <li class="my-1">With your consent.</li>
                    <li class="my-1">With service providers who support our operations.</li>
                    <li class="my-1">With affiliated partners for internal purposes.</li>
                    <li class="my-1">When required by law or to protect our rights.</li>
                    <li class="my-1">In the event of a business transaction such as a merger or acquisition.</li>
                </ul>

                <h3 class="my-2 font-bold">4. Cookies and Tracking</h3>
                <p class="ml-3">
                    We use cookies and similar technologies to improve your experience. You can disable cookies via your browser settings.
                    For more details, refer to our Cookie Policy.
                </p>

                <h3 class="my-2 font-bold">5. Your Rights and Choices</h3>
                <ul class="ml-10 list-disc">
                    <li class="my-1">Access and Correction: You may access and update your information by contacting us.</li>
                    <li class="my-1">
                        Data Deletion: You can request that we delete your personal data, subject to legal retention requirements.
                    </li>
                    <li class="my-1">
                        Opt-Out: You may unsubscribe from marketing communications by following the instructions in the email or contacting
                        <a href="mailto:info@taxilla.com">info&#64;taxilla.com</a>
                        .
                    </li>
                </ul>

                <h3 class="my-2 font-bold">6. Data Storage and Transfers</h3>
                <p class="ml-3">
                    Your data may be stored on servers located inside or outside of India. By using our Services, you consent to this
                    transfer and storage.
                </p>

                <h3 class="my-2 font-bold">7. Children's Privacy</h3>
                <p class="ml-3">
                    Our Services are not intended for children under 18 years of age. We do not knowingly collect data from minors.
                </p>

                <h3 class="my-2 font-bold">8. Data Security</h3>
                <p class="ml-3">
                    We use appropriate technical and organizational measures to safeguard your information. However, no system can be
                    guaranteed 100% secure.
                </p>

                <h3 class="my-2 font-bold">9. Policy Updates</h3>
                <p class="ml-3">
                    This Policy may change from time to time. Changes will be posted on this page with a revised effective date. You are
                    advised to review it periodically.
                </p>

                <h3 class="my-2 font-bold">10. Dispute Resolution</h3>
                <p class="ml-3">
                    Any disputes arising under this Policy shall be resolved through arbitration under the Arbitration and Conciliation Act,
                    1996. The arbitration shall be held in Hyderabad, Telangana, and governed by the laws of India.
                </p>

                <h3 class="my-2 font-bold">11. Contact Us</h3>
                <p class="ml-3">If you have questions about this Policy or wish to exercise your rights, please contact:</p>
                <p class="ml-6">
                    Taxilla IT Solutions Pvt. Ltd.
                    <br />
                    First Floor, South-West Block, Display Building, NAC Campus, Cyberabad, Kondapur Post, Hyderabad, Telangana – 500084
                    <br />
                    Email:
                    <a href="mailto:info@taxilla.com">info&#64;taxilla.com</a>
                </p>
            </div>
        </mat-tab>
        <mat-tab label="Country Specific Terms & Conditions">
            <div class="p-6 prose max-w-none">
                <h2 class="text-xl font-bold text-center">Country Specific Terms & Conditions</h2>
                <p class="text-center">Effective Date: July 15, 2025</p>

                <h3 class="my-2 font-bold">1. Kingdom of Saudi Arabia (KSA)</h3>
                <p class="ml-6">
                    1.1. The Customer confirms that it has obtained all required regulatory permits from ZATCA and other relevant
                    authorities permitting Taxilla to process e-Invoices and related data on its behalf.
                </p>
                <p class="ml-6">
                    1.2. The Customer shall be responsible for compliance with Saudi e-Invoicing Regulations, including but not limited to
                    the use of qualified digital certificates and formats.
                </p>
                <p class="ml-6">
                    1.3. All personal data processing shall comply with applicable local data protection frameworks and obligations under
                    Saudi law.
                </p>

                <h3 class="my-2 font-bold">2. United Arab Emirates (UAE)</h3>
                <p class="ml-6">
                    2.1. The Customer warrants compliance with the UAE Federal Decree Law No. 45 of 2021 (Personal Data Protection Law).
                </p>
                <p class="ml-6">
                    2.2. Customer agrees that data may be transferred outside the UAE and will ensure all lawful mechanisms (including
                    approvals where applicable) are in place for such transfers.
                </p>
                <p class="ml-6">
                    2.3. The Customer shall notify Taxilla if any specific data localization or regulatory approvals are required.
                </p>

                <h3 class="my-2 font-bold">3. Malaysia</h3>
                <p class="ml-6">3.1. The Customer shall comply with the Malaysian Personal Data Protection Act 2010 (PDPA).</p>
                <p class="ml-6">
                    3.2. The Customer confirms that it has obtained the necessary consents from data subjects for processing and sharing of
                    personal data with Taxilla.
                </p>
                <p class="ml-6">
                    3.3. Where applicable, the Customer shall maintain a data user registration with the Department of Personal Data
                    Protection (JPDP).
                </p>

                <h3 class="my-2 font-bold">4. Singapore</h3>
                <p class="ml-6">
                    4.1. The Customer shall comply with the Personal Data Protection Act 2012 (PDPA) including all obligations related to
                    notification, consent, and data subject access.
                </p>
                <p class="ml-6">
                    4.2. Taxilla shall act as a data intermediary under the PDPA and process personal data strictly in accordance with
                    Customer's written instructions.
                </p>
                <p class="ml-6">4.3. Customer shall ensure that any cross-border transfer of personal data is permitted under the PDPA.</p>

                <h3 class="my-2 font-bold">5. Australia</h3>
                <p class="ml-6">5.1. The Customer shall comply with the Privacy Act 1988 and the Australian Privacy Principles (APPs).</p>
                <p class="ml-6">
                    5.2. Customer consents to the offshore transfer of personal data in accordance with APP 8 and assumes responsibility for
                    ensuring that Taxilla's services meet equivalent protections.
                </p>
                <p class="ml-6">
                    5.3. Where sensitive information is processed, Customer must obtain specific and informed consent from data subjects.
                </p>

                <h3 class="my-2 font-bold">6. New Zealand</h3>
                <p class="ml-6">6.1. The Customer warrants compliance with the New Zealand Privacy Act 2020.</p>
                <p class="ml-6">
                    6.2. Customer confirms it has notified data subjects that personal information may be transferred to third parties
                    including Taxilla for service fulfillment.
                </p>
                <p class="ml-6">
                    6.3. Where applicable, the Customer is responsible for data breach notifications to the Office of the Privacy
                    Commissioner.
                </p>

                <h3 class="my-2 font-bold">7. Kenya</h3>
                <p class="ml-6">
                    7.1. The Customer shall comply with the Data Protection Act, 2019, including appointment of a Data Protection Officer
                    where mandated.
                </p>
                <p class="ml-6">
                    7.2. Customer shall obtain informed consent from data subjects for processing and cross-border transfers.
                </p>
                <p class="ml-6">
                    7.3. Where required, the Customer shall register as a Data Controller or Data Processor with the Office of the Data
                    Protection Commissioner.
                </p>

                <h3 class="my-2 font-bold">8. Zambia</h3>
                <p class="ml-6">8.1. The Customer affirms compliance with the Data Protection Act No. 3 of 2021 of Zambia.</p>
                <p class="ml-6">
                    8.2. Customer must ensure all consents, registrations, and approvals required under the law are obtained prior to using
                    the Services.
                </p>
                <p class="ml-6">
                    8.3. Taxilla shall not be liable for any delays in service arising from the Customer's failure to secure regulatory
                    approvals or provide required documentation.
                </p>

                <h3 class="my-2 font-bold">9. Egypt</h3>
                <p class="ml-6">9.1. The Customer shall comply with Law No. 151 of 2020 on the Protection of Personal Data.</p>
                <p class="ml-6">
                    9.2. Customer must obtain the necessary consents from individuals and where applicable, approvals from the Egyptian Data
                    Protection Center for data processing by Taxilla.
                </p>
                <p class="ml-6">
                    9.3. The Customer shall notify Taxilla of any sector-specific compliance obligations (e.g., financial sector).
                </p>

                <h3 class="my-2 font-bold">10. Romania</h3>
                <p class="ml-6">
                    10.1. The Customer shall comply with Regulation (EU) 2016/679 (GDPR) and any applicable national data protection laws.
                </p>
                <p class="ml-6">
                    10.2. Where data is transferred outside the EU, the Customer confirms that appropriate safeguards (e.g., Standard
                    Contractual Clauses) are in place.
                </p>
                <p class="ml-6">
                    10.3. The Customer shall notify data subjects of Taxilla's role as a data processor and record the same under Article 30
                    of GDPR.
                </p>

                <h3 class="my-2 font-bold">11. Germany</h3>
                <p class="ml-6">11.1. The Customer shall comply with both the GDPR and the Federal Data Protection Act (BDSG).</p>
                <p class="ml-6">
                    11.2. Where employee data is processed, the Customer shall obtain explicit consent or demonstrate legitimate processing
                    grounds under Section 26 BDSG.
                </p>
                <p class="ml-6">
                    11.3. The Customer must inform Taxilla of any co-determination rights (e.g., works council involvement) applicable to
                    the processing of personal data in Germany.
                </p>
            </div>
        </mat-tab>
        <mat-tab label="Service Level Agreement">
            <div class="p-6 prose max-w-none">
                <h2 class="text-xl font-bold text-center">Service Level Agreement</h2>
                <p class="text-center">Effective Date: July 15, 2025</p>

                <h3 class="my-2 font-bold">1. General Overview</h3>
                <p class="ml-6">
                    1.1. This Service Level Agreement ("SLA") is a part of the Agreement between Taxilla and the Customer and governs the
                    support services related to the Taxilla services ("Services").
                </p>
                <p class="ml-6">
                    1.2. This document remains in effect for the duration of the Agreement and applies to all Customers with an active
                    subscription whose account is current (i.e. not past due), including timely payment for any optional services.
                </p>

                <h3 class="my-2 font-bold">2. Definitions</h3>
                <p class="ml-6">
                    2.1. "Agreement" means the agreement for the provision of Services by Taxilla to the Customer, of which this SLA forms
                    an integral part.
                </p>
                <p class="ml-6">2.2. "Customer" is the subscriber of Taxilla services under the Agreement.</p>
                <p class="ml-6">2.3. "Issue" is a problem related to the Services that affects the Customer's business operations.</p>
                <p class="ml-6">2.4. "Support Enquiry" is a request submitted by the Customer for assistance regarding the Services.</p>
                <p class="ml-6">
                    2.5. "Support Channels" include the ticketing system, email support, phone support, and chat support as specified in the
                    support plan.
                </p>
                <p class="ml-6">2.6. "Taxilla Support" refers to Taxilla's customer service organization handling Support Enquiries.</p>
                <p class="ml-6">2.7. "Severity Level" indicates the priority of the Issue based on its business impact.</p>

                <h3 class="my-2 font-bold">3. Description of Services</h3>
                <div class="ml-6 my-4">
                    <table class="min-w-full border-collapse border border-gray-300">
                        <thead>
                            <tr class="bg-gray-100">
                                <th class="border border-gray-300 px-4 py-2">Services</th>
                                <th class="border border-gray-300 px-4 py-2">Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="border border-gray-300 px-4 py-2 font-semibold">What services are included in this SLA?</td>
                                <td class="border border-gray-300 px-4 py-2">
                                    a) Error corrections and updates
                                    <br />
                                    b) Maintenance releases and upgrades
                                </td>
                            </tr>
                            <tr>
                                <td class="border border-gray-300 px-4 py-2 font-semibold">What services are NOT included in this SLA?</td>
                                <td class="border border-gray-300 px-4 py-2">
                                    - Problem with third party software not licensed through provider
                                    <br />
                                    - Problem is with individual users desktop or browser software
                                    <br />
                                    - Customer has not paid license subscription
                                </td>
                            </tr>
                            <tr>
                                <td class="border border-gray-300 px-4 py-2 font-semibold">How will service be delivered?</td>
                                <td class="border border-gray-300 px-4 py-2">Through remote connections, telephone, email and Webinar</td>
                            </tr>
                            <tr>
                                <td class="border border-gray-300 px-4 py-2 font-semibold">
                                    When will regularly scheduled maintenance be performed?
                                </td>
                                <td class="border border-gray-300 px-4 py-2">
                                    Taxilla follows a zero-downtime deployment model to ensure uninterrupted service availability. In the
                                    rare event that a patch or upgrade necessitates scheduled downtime, customers will be informed well in
                                    advance to minimize any potential disruption.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h3 class="my-2 font-bold">4. Taxilla Support</h3>
                <p class="ml-6">
                    4.1. Taxilla provides support services to Customers under three tiers: Standard, Priority, and Premium, based on the
                    Customer's preference. Standard support is included with the subscription; Priority and Premium plans are available at
                    an additional cost.
                </p>
                <p class="ml-6">4.2. Support Plan Details:</p>

                <div class="ml-6 my-4">
                    <table class="min-w-full border-collapse border border-gray-300">
                        <thead>
                            <tr class="bg-gray-100">
                                <th class="border border-gray-300 px-4 py-2">Support Plan</th>
                                <th class="border border-gray-300 px-4 py-2">Eligibility</th>
                                <th class="border border-gray-300 px-4 py-2">Support Cost</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="border border-gray-300 px-4 py-2">Standard</td>
                                <td class="border border-gray-300 px-4 py-2">Included with any App subscription</td>
                                <td class="border border-gray-300 px-4 py-2">Included</td>
                            </tr>
                            <tr>
                                <td class="border border-gray-300 px-4 py-2">Priority</td>
                                <td class="border border-gray-300 px-4 py-2">Included with any App subscription</td>
                                <td class="border border-gray-300 px-4 py-2">** Additional charges may apply.</td>
                            </tr>
                            <tr>
                                <td class="border border-gray-300 px-4 py-2">Premium</td>
                                <td class="border border-gray-300 px-4 py-2"></td>
                                <td class="border border-gray-300 px-4 py-2">** Additional charges may apply.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <p class="ml-6">4.3. Response Time & Availability:</p>

                <div class="ml-6 my-4">
                    <table class="min-w-full border-collapse border border-gray-300">
                        <thead>
                            <tr class="bg-gray-100">
                                <th class="border border-gray-300 px-4 py-2"></th>
                                <th class="border border-gray-300 px-4 py-2">Standard</th>
                                <th class="border border-gray-300 px-4 py-2">Priority</th>
                                <th class="border border-gray-300 px-4 py-2">Premium</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="border border-gray-300 px-4 py-2 font-semibold">Response Time</td>
                                <td class="border border-gray-300 px-4 py-2">
                                    Severity 1: 1 hour, 24/7
                                    <br />
                                    Severity 2-4: 2 business days
                                </td>
                                <td class="border border-gray-300 px-4 py-2">
                                    Severity 1: 1 hour, 24/7
                                    <br />
                                    Severity 2-4: 8 business hours
                                </td>
                                <td class="border border-gray-300 px-4 py-2">
                                    Severity 1: 1 hour, 24/7
                                    <br />
                                    Severity 2-4: 4 hours, 24/7
                                </td>
                            </tr>
                            <tr>
                                <td class="border border-gray-300 px-4 py-2 font-semibold">Business Hours</td>
                                <td class="border border-gray-300 px-4 py-2">8 am to 8 pm</td>
                                <td class="border border-gray-300 px-4 py-2">24/5: from Sun 5pm to Fri 8pm</td>
                                <td class="border border-gray-300 px-4 py-2">24/7</td>
                            </tr>
                            <tr>
                                <td class="border border-gray-300 px-4 py-2 font-semibold">Phone Support</td>
                                <td class="border border-gray-300 px-4 py-2">Only for Severity-1 (Production is down).</td>
                                <td class="border border-gray-300 px-4 py-2">Yes</td>
                                <td class="border border-gray-300 px-4 py-2">Yes</td>
                            </tr>
                            <tr>
                                <td class="border border-gray-300 px-4 py-2 font-semibold">Email Support</td>
                                <td class="border border-gray-300 px-4 py-2">Yes</td>
                                <td class="border border-gray-300 px-4 py-2">Yes</td>
                                <td class="border border-gray-300 px-4 py-2">Yes</td>
                            </tr>
                            <tr>
                                <td class="border border-gray-300 px-4 py-2 font-semibold">Chat Support</td>
                                <td class="border border-gray-300 px-4 py-2">Only for Severity-1 (Production is down).</td>
                                <td class="border border-gray-300 px-4 py-2">Yes</td>
                                <td class="border border-gray-300 px-4 py-2">Yes</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <p class="ml-6">4.4. Provider duties and responsibilities:</p>
                <ul class="ml-10 list-disc">
                    <li class="my-1 ml-2">Triage and categorize the problem incidents</li>
                    <li class="my-1 ml-2">Communicate work-around as needed.</li>
                    <li class="my-1 ml-2">Seek additional inputs from customer if required</li>
                    <li class="my-1 ml-2">Adhere to the service level commitments</li>
                    <li class="my-1 ml-2">Provide status reporting</li>
                </ul>

                <p class="ml-6">4.5. Customers must report problem incidents through agreed support channels and provide:</p>
                <ul class="ml-10 list-disc">
                    <li class="my-1 ml-2">Description of the problem and its business impact</li>
                    <li class="my-1 ml-2">Any error messages or logs</li>
                    <li class="my-1 ml-2">Steps taken for resolution</li>
                    <li class="my-1 ml-2">Contact point for communication</li>
                </ul>

                <p class="ml-6">
                    4.6. Taxilla Support triages issues, assigns severity, provides updates, and communicates workarounds where needed.
                </p>
                <p class="ml-6">
                    4.7. Taxilla provides support only to the Customer and holds no responsibility for third-party systems, including the
                    Customer's clients or trading partners.
                </p>

                <h3 class="my-2 font-bold">5. Service Status and Notifications</h3>
                <p class="ml-6">
                    Taxilla may share performance status and known issues on designated support channels such as Tracet
                    <a href="https://app.tracet.in/">(https://app.tracet.in/)</a>
                    . Customers are advised to follow such portals to receive real-time notifications.
                </p>

                <h3 class="my-2 font-bold">6. Support Contacts</h3>
                <ul class="ml-10 list-disc">
                    <li class="my-1">Helpdesk Number: 040-66033573 (India), 040-66033550 (KSA & Malaysia)</li>
                    <li class="my-1">
                        Ticketing URL:
                        <a href="https://app.tracet.in/">https://app.tracet.in/</a>
                    </li>
                    <li class="my-1">
                        Support Email:
                        <br />
                        India - Encomply Tech Support
                        <a href="mailto:encomplyts@taxilla.com">encomplyts&#64;taxilla.com</a>
                        <br />
                        KSA - KSA Tech Support
                        <a href="mailto:ksatechsupport@taxilla.com">ksatechsupport&#64;taxilla.com</a>
                        <br />
                        Malaysia – Malaysia Tech Support
                        <a href="mailto:mystechsupport@taxilla.com">mystechsupport&#64;taxilla.com</a>
                    </li>
                </ul>

                <p class="ml-6 mt-4">Escalation Contacts:</p>
                <div class="ml-6 my-4">
                    <table class="min-w-full border-collapse border border-gray-300">
                        <thead>
                            <tr class="bg-gray-100">
                                <th class="border border-gray-300 px-4 py-2">Escalation Level</th>
                                <th class="border border-gray-300 px-4 py-2">Contact Person</th>
                                <th class="border border-gray-300 px-4 py-2">Designation</th>
                                <th class="border border-gray-300 px-4 py-2">Email ID</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="border border-gray-300 px-4 py-2">Level 1</td>
                                <td class="border border-gray-300 px-4 py-2">Sravani Chinthala</td>
                                <td class="border border-gray-300 px-4 py-2">Service Manager</td>
                                <td class="border border-gray-300 px-4 py-2">
                                    <a href="mailto:schinthala@taxilla.com">schinthala&#64;taxilla.com</a>
                                </td>
                            </tr>
                            <tr>
                                <td class="border border-gray-300 px-4 py-2">Level 2</td>
                                <td class="border border-gray-300 px-4 py-2">Harish Chittineni</td>
                                <td class="border border-gray-300 px-4 py-2">Customer Account Manager / Head – Customer Success</td>
                                <td class="border border-gray-300 px-4 py-2"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h3 class="my-2 font-bold">7. Change and Release Management</h3>
                <p class="ml-6">
                    The Customer shall inform Taxilla of any major business changes impacting technology usage. Taxilla will likewise inform
                    the Customer of any significant changes or releases that may affect the Services.
                </p>

                <h3 class="my-2 font-bold">8. SLA Review and Modification</h3>
                <p class="ml-6">8.1. This SLA is subject to periodic review and may be updated based on:</p>
                <ul class="ml-10 list-disc">
                    <li class="my-1">Regulatory or business model changes (e.g., updates from IRP, ZATCA, KSeF, IRBM, DGFiP, IRAS etc.)</li>
                    <li class="my-1">Changes in customer requirements or expectations</li>
                    <li class="my-1">Shifts in workload</li>
                </ul>
                <p class="ml-6">
                    8.2. A minimum annual review will be conducted. Any amendments must be mutually agreed upon and communicated to all
                    stakeholders.
                </p>
            </div>
        </mat-tab>
    </mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions align="center" class="p-2 border-t border-gray-200 !block mb-0">
    <material-button
        [color]="'primary'"
        [text]="'Accept'"
        [classList]="['mt-2', '!w-[75px]']"
        (buttonClicked)="acceptEula(); closeBtnAction()"></material-button>
</mat-dialog-actions>
